import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { select } from '@/store'
import { isNullOrEmpty } from '@/utils'

interface Props {
  listingId: string
}
// globalize
const useLoadListing = ({ listingId }: Props) => {
  const dispatch = useDispatch()

  useEffect(() => {
    async function reload() {
      if (!listingId) return
      await dispatch.listing.load(listingId)
    }
    reload()
  }, [dispatch.listing, listingId])

  const listing = useSelector(state =>
    (select.listing.editListing as any)(state, {
      listingId
    })
  )
  return { listing, isLoading: isNullOrEmpty(listing) }
}

export default useLoadListing
